import axios from "axios";
import { getAuthToken, getCreatedBy, getFacilityId, getModifiedBy } from "../../../utility/tokenUtility";
import { BemsGraph, FemsGraph} from "../../../utility/apiURLS";
import dayjs from 'dayjs';

const changeDateFormat = (date) => {
    if (!date || !dayjs(date, 'DD/MM/YYYY').isValid() || date === 'Invalid Date' || date == null) {
        return '';
    }
    const convertedDate = dayjs(date, 'DD/MM/YYYY').format("YYYY-MM-DD");
    const finalDate = `${convertedDate}T00:00:00`;
    return finalDate;
};
const getCommonpayloadData = (formData) => {
    return {
        //basicDetails
        id: formData?.id || '',
        model: formData?.model || '',
        serialno: formData?.serialno || '',
        userlocationid: formData?.location?.id || "00000000-0000-0000-0000-000000000000", //when no location is selected pass 00000000-0000-0000-0000-000000000000
        purchaseprice: formData?.purchaseprice || '',
        financeassetno: formData?.financeassetno || '',
        isunderwarranty: formData?.isunderwarranty || '',
        warrantystartdate: formData?.warrantystartdate && changeDateFormat(formData.warrantystartdate) || '',
        warrantyexpirydate: formData?.warrantyexpirydate && changeDateFormat(formData.warrantyexpirydate) || '',
        lifespan: formData?.lifespan || '',
        istestpassed: formData?.istestpassed ? formData?.istestpassed?.value : '',
        testingcommissioncompletedate: formData?.testingcommissioncompletedate && changeDateFormat(formData?.testingcommissioncompletedate) || '',
        remarks: formData?.remarks || '',
        referenceno: formData?.referenceno || '',
        class: formData?.class || '',
        type: formData?.type || '',
        powercord: formData?.powercord || '',
        isdefibrillationproof: formData?.isdefibrillationproof || '',
        chassisno: formData?.chassisno || '',
        purchaseorderno: formData?.purchaseorderno || '',
        registerno: formData?.registerno || '',
        manufacturer: formData?.manufacturer || '',
        processingpercentage: formData?.processingpercentage || '',
    }
};

const femPayloadData = (formData) => {
    return {
        femworkgroupdetails: {
            id: formData?.workgroup?.id || '',
            groupname: formData?.workgroup?.label || '', 
        },
        femtestingcommissionstatus: {
            id: '',
            Testcommissionstatus: '', 
        },
        femtestingriskstatus: formData?.criticality?.id ? {
            id: formData?.criticality?.id || '',
            Riskstatus: formData?.criticality?.label || '', 
        } : "",
    }
};

const bemPayloadData = (formData) => {
    return {
        bemworkgroupdetails: {
            id: formData?.workgroup?.id || '',
            groupname: formData?.workgroup?.label || '',
        },
        bemtestingcommissionstatus: {
            id: '',
            Testcommissionstatus: '',
        },
        bemtestingriskstatus: formData?.criticality?.id ? {
            id: formData?.criticality?.id || '',
            Riskstatus: formData?.criticality?.label || '',
        } : "",
    };
};

const createTC = async (formData, status, serviceType) => {
    const facilityId = getFacilityId("facilityId");
    const payloadData = getCommonpayloadData(formData);
    const createdBy = getCreatedBy('UserId');
    const currentDate = dayjs().format('YYYY-MM-DDTHH:mm:ss');
    const createPayload = {
        service: formData?.service?.id || '',
        vendorid: formData?.vendorname?.id || '',
        typecodeid: formData?.typecode?.id || '',
        assetdesc: formData?.assetdesc || '',
        testingcommissionstartdate: currentDate || '', //need to remove this filed as client adviced to remove it
        facilityid: formData?.facilityid || facilityId,
        testingcommissionno: formData?.testingcommissionno,
    }
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        if (serviceType === 'FEMS') {
            const fempayload = femPayloadData(formData);
            const payload = { ...payloadData, ...fempayload, ...createPayload }
            const mergedPayload = { ...payload, createdby: createdBy, femtestingcommissionstatus: status }
            const response = await axios.post(`${FemsGraph}/api/femtestingandcommissions`, mergedPayload, config);
            if (response.status >= 200 && response.status <= 204) {
                return response.data;
            }
        }
        else if (serviceType === 'BEMS') {
            const bempayload = bemPayloadData(formData);
            const payload = { ...payloadData, ...bempayload,...createPayload }
            const mergedPayload = { ...payload, createdby: createdBy, bemtestingcommissionstatus: status }
            const response = await axios.post(`${BemsGraph}/api/bemtestingandcommissions`, mergedPayload, config);
            if (response.status >= 200 && response.status <= 204) {
                return response.data;
            }
        }
    } catch (error) {
        if(error?.response?.data?.detail=="TestingandCommission  Already Exists "){
return error?.response?.data?.detail;
        }else{
            console.error('Save error:', error);
        }
    }
};

const updateTC = async (formData, id, serviceType, status) => {
    const modifiedBy = getModifiedBy('modifiedBy');
    const modifiedDate=dayjs().format('YYYY-MM-DDTHH:mm:ss');
    const payloadData = getCommonpayloadData(formData);
    try {
        const token = getAuthToken("id_token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        let mergedPayload = {};
        if (serviceType === 'FEMS') {
            mergedPayload = { ...payloadData, id: id, modifiedby: modifiedBy,modifieddate:modifiedDate, femtestingcommissionstatusid: status?.id, femtestingriskstatusId: formData?.criticality?.id ? formData?.criticality?.id : "" }; //for update API need to pass only id for femtestingcommissionstatus
            const response = await axios.put(`${FemsGraph}/api/TestingandCommission/UpdateTestingandcommissionfems/${id}`, mergedPayload, config);
            if (response.status >= 200 && response.status <= 204) {
                return response.data;
            }
        } else if (serviceType === 'BEMS') {
            mergedPayload = { ...payloadData, id: id, modifiedby: modifiedBy,modifieddate:modifiedDate, bemtestingcommissionstatusid: status?.id,bemtestingriskstatusId: formData?.criticality?.id ? formData?.criticality?.id : "" };
            const response = await axios.put(`${BemsGraph}/api/TestingandCommission/UpdateTestingandcommissionbems/${id}`, mergedPayload, config);
            if (response.status >= 200 && response.status <= 204) {
                return response.data;
            }
        }
    } catch (error) {
        console.error('Update error:', error);
    }
};

export const tcCreateUpdateRepository = {
    createTC,
    updateTC
};